import React, { useState } from "react"

import PropTypes from "prop-types"
import ThemeContext from "../context/ThemeContext"
import "react-image-lightbox/style.css"
import "bootstrap/dist/css/bootstrap.css"
import "../custom-css-bootstrap.css"
import styled from "styled-components"
import { HamburgerIconStyled, NavbarStyled } from "@/components/navbar/navbarStyle"
import Logo from "@/components/shared/logo/logo"
import { Link } from "gatsby-plugin-intl"


const LayoutEmpty = ({
  children
}) => {
  const [navState, toggleNav] = useState(false)

  return (
    <>
      <ThemeContext.Consumer>
        {theme => (
          <FontStyle>
            <div className="app-content">
              <MainContainer>
                <NavbarStyled
                  pose={navState ? "open" : "closed"}



                >
                  <div className="navigation">
                    <div className="logo">
                      <Link to="/">
                        <Logo theme={"dark"} />
                      </Link>
                    </div>
                    <HamburgerIconStyled
                      onClick={() => toggleNav(!navState)}
                      navOpen={navState}
                    >
                      <button
                        className={`hamburger ${navState && "close-button"}`}
                      >
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                      </button>
                    </HamburgerIconStyled>
                  </div>
                  <div
                    className={`nav-content nav-content--lite`}
                  >
                    <ul>

                      <Link to="/">
                        przejdź na willbud.pl
                      </Link>
                      <Link to="/"></Link>
                    </ul>
                  </div>
                </NavbarStyled>
                {children}
              </MainContainer>

            </div>
          </FontStyle>
        )}
      </ThemeContext.Consumer>
    </>
  )
}
LayoutEmpty.propTypes = {
  children: PropTypes.node.isRequired,
}

const FontStyle = styled.div`
  font-family: "futura-pt", sans-serif !important;
  overflow: hidden;
`
const MainContainer = styled.div`
  position: relative;
  z-index: 1;
  .padding30 {
    padding: 0 30px;
  }
`
export default LayoutEmpty
